import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response';
import {
  CreateApiCredentialResponse,
  OrganizationApiCredential
} from '../../models/organization-api-credential';

@Injectable({ providedIn: 'root' })
export class ApiCredentialsService {
  constructor(private http: HttpClient) {}

  getCredentials(
    organizationId: string,
    page: number,
    size: number
  ): Observable<ApiResponse<OrganizationApiCredential[]>> {
    const params = new HttpParams()
      .set('page', page)
      .set('size', size);

    return this.http.get<ApiResponse<OrganizationApiCredential[]>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/api-credentials`,
      { params }
    );
  }

  createCredential(organizationId: string) {
    return this.http.post<ApiResponse<CreateApiCredentialResponse>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/api-credentials`,
      {}
    );
  }

  revokeCredential(organizationId: string, credentialId: string) {
    return this.http.post<ApiResponse<OrganizationApiCredential>>(
      `${environment.apiBaseUrl}/admin/organizations/${organizationId}/api-credentials/${credentialId}/revoke`,
      {}
    );
  }
}